module.exports = __webpack_public_path__ + "img/user.f4fc8aea.svg";